module.exports = __webpack_public_path__ + "img/SES_194258650.229353a1.jpg";